// extracted by mini-css-extract-plugin
export default {"list":"list-module--list--SKwT3","item":"list-module--item--L-Lnj","bullet":"list-module--bullet--FVW10","title":"list-module--title--g7Bz2","link":"list-module--link--p3fDv"};